import { HighPrioritySchoolIndicator } from '@/components/high-priority-school-indicator.js';
import { formatInstant, FrequentTimeZones } from '@airreading/common';
import { Link } from '@tanstack/react-router';
import { Temporal } from 'temporal-polyfill';

const linkClassName = 'text-blue-600 hover:text-blue-800';

interface TqReviewMostRecentSessionDateProps {
  instant: Temporal.Instant | null;
  sessionId: string | null;
  isHighPrioritySchool: boolean;
  reviewId: string;
}

export function TqReviewMostRecentSessionDate({
  instant,
  sessionId,
  isHighPrioritySchool,
  reviewId,
}: TqReviewMostRecentSessionDateProps) {
  const dateLabel = instant ? formatInstant(instant, FrequentTimeZones.UsCentral).formattedDate : null;

  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap">
      {dateLabel && sessionId ? (
        <Link to="/sessions/$sessionId" params={{ sessionId }} search={{ from: 'past' }} className={linkClassName}>
          {dateLabel}
        </Link>
      ) : (
        '—'
      )}
      <HighPrioritySchoolIndicator
        isHighPriority={isHighPrioritySchool}
        data-testid={`teachers-tq-review-table-icon-high-priority-school-${reviewId}`}
      />
    </span>
  );
}
